import {
  Breadcrumb,
  Button,
  Card,
  Empty,
  Form,
  Modal,
  Select,
  Tabs,
} from "antd";
import { useCallback, useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router";
import AccountService from "../../../../services/accounts.service";
import moment from "moment";
import Loader from "../../../../components/loader";
import { AiOutlineLeft } from "react-icons/ai";
import {
  amountFormat,
  maskAccountNumber,
} from "../../../../services/common.service";
import SetStatementRemarks from "../statement-remarks";
import { MdOutlineEdit } from "react-icons/md";
import { ReactComponent as TitleIcon } from "../../../../assests/images/accountBread.svg";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { accountListSelector, selectedAccountSelector } from "../../../../store/selectors/app.selector";
import AccountMiniStatementGrid from "../../../../components/account-mini-statement-grid";
import AccountMiniStatementList from "../../../../components/account-mini-statement-list";

const remarksBill = require("../../../../assests/icons/d_bill.png");
const remarksBusiness = require("../../../../assests/icons/d_business.png");
const remarksEntertainment = require("../../../../assests/icons/d_entertainment.png");
const remarksfood = require("../../../../assests/icons/d_food.png");
const remarksHelth = require("../../../../assests/icons/d_health.png");
const remarksOthers = require("../../../../assests/icons/d_others.png");
const remarksShopping = require("../../../../assests/icons/d_shopping.png");
const remarksTravel = require("../../../../assests/icons/d_travel.png");
const remarksInvestment = require("../../../../assests/icons/d_investment.png");

const remarksIcons = {
  FOOD: remarksfood,
  ENTERTAINMENT: remarksEntertainment,
  BILLS: remarksBill,
  TRAVEL: remarksTravel,
  HEALTH: remarksHelth,
  INVESTMENT: remarksInvestment,
  SHOPPING: remarksShopping,
  BUSINESS: remarksBusiness,
  OTHERS: remarksOthers,
};

export default function MiniStatement() {
  const navigate = useNavigate();
  const location = useLocation();
  const [accountDetails, setAccountDetails] = useState({});
  const [dataSource, setDataSource] = useState([]);
  const [noRecords, setNoRecords] = useState(false);
  const [loader, setLoader] = useState(false);
  const [visible, setVisible] = useState(false);
  const [selectedDetails, setSelectedDetails] = useState({});
  const [accNo, setAccNo] = useState("");
  const { t } = useTranslation();
  const [activeKey, setActiveKey] = useState("ACCOUNT_DETAILS");
  const accountList = useSelector(accountListSelector);
  const [selectedAccountNo, setSelectedAccountNo] = useState(
    location.state.accountNo
  );
  const [showGridAccount, setShowGridAccount] = useState("GRID");
  const selectedAccount = useSelector(selectedAccountSelector);

  useEffect(() => {
    if (window.innerWidth < 900) {
      setShowGridAccount("LIST");
    }
  }, [window.innerWidth]);

  // useEffect(() => {
  //   if (location.pathname === "/accounts/statement") {
  //     setActiveKey("MINI_STATEMENT");
  //   } else {
  //     setActiveKey("ACCOUNT_DETAILS");
  //   }
  //   if (location.state) {
  //     setAccountDetails(location.state);
  //     getLastNTransactions(location.state);
  //     setAccNo(location.state?.accountNo);
  //   }
  // }, []);

  const handleAccountNo = (value) => {
    setDataSource([]);
    setSelectedAccountNo(value);
    const accountDet = accountList.find((ele) => ele.accountNo === value);
    setAccountDetails(accountDet);
    getLastNTransactions(accountDet);
  };

  useEffect(() => {
    if (selectedAccount) {
      setAccountDetails(selectedAccount);
      getLastNTransactions(selectedAccount);
    }
  }, [selectedAccount]);

  // const handleTabClick = (key) => {
  //   setActiveKey(key);
  //   if (key === "ACCOUNT_DETAILS") {
  //     navigate("/accounts/summary", { state: accountDetails });
  //   }
  //   if (key === "DETAILED_STATEMENT") {
  //     navigate("/accounts/statement/detailed", {
  //       state: accountDetails,
  //     });
  //   }
  //   if (key === "E_STATEMENT") {
  //     navigate("/accounts/statement/eStatement", {
  //       state: accountDetails,
  //     });
  //   }
  //   if (key === "VIEW_BALANCES") {
  //     navigate("/accounts/summary/balances", {
  //       state: accountDetails,
  //     });
  //   }
  // };

  const getLastNTransactions = useCallback(async (details) => {
    try {
      setLoader(true);
      const response = await AccountService.getLastNTransactions({
        accountNo: details?.accountNo,
        branchId: details?.branchId,
        requestId: "MINISTATEMENT",
      });

      if (response.status === 200) {
        setLoader(false);
        setDataSource(response.data["transactionDetails"]);
        setNoRecords(
          response.data["transactionDetails"].length > 0 ? false : true
        );
      }
    } catch (error) {
      setLoader(false);
      setNoRecords(true);
    }
  }, []);

  return (
    <>
      {/* 
      
        <Breadcrumb separator=">">
          <Breadcrumb.Item>
            <span onClick={() => navigate("/dashboard")}>
              <HomeIcon height={14}/>
            </span>
          </Breadcrumb.Item>
          <Breadcrumb.Item>
            <span onClick={() => navigate("/accounts")}>
              {" "}
              {t("navigation.account", {
                defaultValue: "Accounts",
              })}
            </span>
          </Breadcrumb.Item>
          <Breadcrumb.Item>
            <span>
              {t("navigation.statement", {
                defaultValue: "Statement",
              })}
            </span>
          </Breadcrumb.Item>
        </Breadcrumb>
     
      <Card size="small" className="mb-1 text-center breadcrumb-title-card">
        <div className="row">
          <div className="col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6 d-flex justify-content-left align-items-center heading mx-0">
            {/* <TitleIcon height={30} style={{ marginLeft: "-20px" }} /> }
            <h3 className="title mb-0">
              {t("navigation.statement", {
                defaultValue: "Statement",
              })}
            </h3>
          </div>
          <div className="col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6 hide-xs d-flex justify-content-end">
            <label style={{ fontSize: "16px", padding: "5px" }}>
              {t("common.account_no_lbl", {
                defaultValue: "Account Number",
              })}{" "}
              :{" "}
            </label>
            <Select
              placeholder={t("common.account_no_lbl", {
                defaultValue: "Account Number",
              })}
              bordered={true}
              optionLabelProp={"value"}
              size="large"
              value={selectedAccountNo}
              onChange={(value) => handleAccountNo(value)}
              style={{ width: "37%", textAlign: "justify" }}
            >
              {accountList.map((account, index) => (
                <Select.Option key={index} value={account.accountNo}>
                  <span className="acc-short-name">
                    {account?.acctShortName}
                  </span>
                  <br />
                  <span style={{ fontSize: "12px" }}>{account?.accountNo}</span>
                  <br />
                  <span style={{ fontSize: "12px" }}>
                    {account?.branchName}
                  </span>
                </Select.Option>
              ))}
            </Select>
          </div>
        </div>
      </Card> */}
      {/* <Card className="account-tab-card mb-1">
        <Tabs
          defaultActiveKey="1"
          type="line"
          onChange={setActiveKey}
          activeKey={activeKey}
          onTabClick={handleTabClick}
        >
          <Tabs.TabPane
            tab={t("pages.gepeg.account_details", {
              defaultValue: "Account Details",
            })}
            key="ACCOUNT_DETAILS"
          ></Tabs.TabPane>
          <Tabs.TabPane
            tab={t("pages.gepeg.view_balances", {
              defaultValue: "View Balances",
            })}
            key="VIEW_BALANCES"
          ></Tabs.TabPane>
          <Tabs.TabPane
            tab={t("navigation.statement", {
              defaultValue: "Statement",
            })}
            key="MINI_STATEMENT"
          ></Tabs.TabPane>
          <Tabs.TabPane
            tab={t("buttons.detailed_stmt_btn", {
              defaultValue: "Detailed Statement",
            })}
            key="DETAILED_STATEMENT"
          ></Tabs.TabPane>
          <Tabs.TabPane
            tab={t("pages.my_accounts.casa.eStatement_Request", {
                      defaultValue: "eStatement Request",
                    })}
            key="E_STATEMENT"
          ></Tabs.TabPane>
        </Tabs>
      </Card> */}

      <div className="mt-2">
        {showGridAccount === "GRID" && (
          <AccountMiniStatementGrid
            dataSource={dataSource}
            accountDetails={accountDetails}
            setVisible = {setVisible}
            setSelectedDetails = {setSelectedDetails}
            remarksIcons={remarksIcons}
            noRecords={noRecords}
          />
        )}
        {showGridAccount === "LIST" && (
          <AccountMiniStatementList dataSource={dataSource} noRecords={noRecords}/>
        )}
      </div>

      <Modal
        title={
          selectedDetails?.remarks !== null &&
          selectedDetails?.remarks?.length > 0
            ? t("pages.my_accounts.casa.edit_remarks", {
                defaultValue: "Edit Remarks",
              })
            : t("pages.my_accounts.casa.add_remarks", {
                defaultValue: "Add Remarks",
              })
        }
        closable={false}
        maskClosable={false}
        open={visible}
        footer={null}
        width={420}
        mask={true}
      >
        <SetStatementRemarks
          key={new Date().getTime()}
          setVisible={setVisible}
          selectedDetails={selectedDetails}
          accountDetails={accountDetails}
          setRefresh={() => {
            setVisible(false);
            getLastNTransactions(accountDetails);
            // dataSource.forEach((ele) => {
            //   if (ele.refNo === selectedDetails?.refNo) {
            //     ele.remarks = data.remarks;
            //     ele.remarksTag = data.remarksTag;
            //   }
            // });
            // setDataSource(dataSource);
          }}
        />
      </Modal>
    </>
  );
}
